export default __webpack_public_path__ + "static/media/finished-unstaking.a5b71db5.png";